<template>
    <li class="ranking-book-card" @click="getBookId">
        <img :src="getImgCover(item.cover)" alt="" v-lazy="getImgCover(item.cover)" data-loading="../assets/imgloading.gif"  data-error="../assets/wrong.png"/>
        <div class="book-detail">
            <h5>{{ num + 1 }}.{{ item.title }}</h5>
            <p>{{ item.shortIntro }}</p>
            <span class="book-author">{{ item.author }}</span>
            <span class="book-minorCate">{{ item.minorCate }}</span>
        </div>
    </li>
</template>

<script>
export default {
    props: ["item", "num"],
    methods: {
        getBookId() {
            this.$router.push({
                path: "singlebookdetail",
                params: {
                    id: this.item._id
                }
            });
            this.$store.commit("setBookDetailId", {
                value: this.item._id
            });
        },
        getImgCover(url) {
            // return url.replace("/agent/","");
            return "https://statics.zhuishushenqi.com" + url;
        }
    }
};
</script>

<style lang="less">
li.ranking-book-card {
    padding: 15px 10px 20px 0;
    // border-bottom: 1px solid rgb(231, 231, 231);
    img {
        float: left;
        width: 70px;
        height: 100px;
        margin-right: 15px;
        border-radius: 2px;
        box-shadow: 0 2px 1px 2px rgba(0, 0, 0, 0.15);
    }
    .book-detail {
        h5 {
            font-size: 14px;
            margin: 5px 0;
             display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
        p {
            color: #999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-size: 10px;
            margin: 5px 0;
        }
        span {
            color: #999;
            font-size: 10px;
            &.book-author {
            }
            &.book-minorCate {
                float: right;
                background: rgb(231, 231, 231);
                color: #666;
                border-radius: 8px;
                padding: 2px 5px;
                transform: scale(0.8);
            }
        }
    }
}
</style>
